import { Navigate, useNavigate, useParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { EmbeddedContext, slug } from "@/components/crm/common";
import { FinanceGate } from "@/components/crm/FinanceLock";

export function Hub({ base, title, tabs }) {
  const { section } = useParams();
  const nav = useNavigate();
  const { can } = useAuth();
  const list = tabs.filter((t) => (t.keys || [t.perm]).some((k) => can(k)));
  if (!list.length) return <Navigate to="/" replace />;
  const cur = list.find((t) => t.key === section);
  if (!cur) return <Navigate to={`${base}/${list[0].key}`} replace />;
  const body = cur.gate ? <FinanceGate key={cur.key} title={cur.label}>{cur.element}</FinanceGate> : cur.element;
  return (
    <div data-testid={`hub-${slug(title)}`} className="space-y-5">
      <div className="flex flex-col gap-3 fade-up md:flex-row md:items-end md:justify-between">
        <h1 data-testid="page-title" className="text-2xl font-extrabold tracking-tight text-zinc-900 sm:text-[28px]">{title}</h1>
        <div className="thin-scroll flex max-w-full gap-1 overflow-x-auto rounded-xl border border-zinc-100 bg-white p-1">
          {list.map((t) => (
            <button key={t.key} data-testid={`hub-tab-${t.key}`} onClick={() => nav(`${base}/${t.key}`)}
              className={`whitespace-nowrap rounded-lg px-3.5 py-1.5 text-xs font-bold transition-colors ${t.key === cur.key ? "bg-[#C5A46D] text-[#171923]" : "text-zinc-500 hover:text-[#C5A46D]"}`}>{t.label}</button>
          ))}
        </div>
      </div>
      <EmbeddedContext.Provider value={true}><div key={cur.key} className="space-y-6">{body}</div></EmbeddedContext.Provider>
    </div>
  );
}
